export const USER_ROLE_ADMIN = 1
export const USER_ROLE_GUEST = 2
export const USER_ROLE_HOST = 3
